export default __webpack_public_path__ + "static/media/dashboard_white.f74a7e41.svg";